import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FCLink from '../fc_link/fc_link';
import Poster from '../poster/poster';
import Eyebrow from '../eyebrow/eyebrow';
import {
  createCardWrapperClasses,
  createCardTextWrapperClasses,
  createCardClasses,
  createCardTitleClasses,
  createCardDeckClasses
} from '../../../utils/create_class_list_util';

export default class Card extends Component {
  shouldComponentUpdate(nextProps) {
    return !!nextProps.metadata.isVideo;
  }

  render() {
    const {
      metadata,
      env,
      hasExcerpt,
      bigStory,
      rowCardCount,
      columnCard,
      className,
      fullPageAdvertorial,
      cardEvent
    } = this.props;

    const cardWrapClasses = createCardWrapperClasses({
      bigStory,
      rowCardCount,
      columnCard,
      className,
      metadata,
      fullPageAdvertorial
    });
    const cardClasses = createCardClasses({
      className,
      columnCard,
      metadata,
      fullPageAdvertorial
    });

    const textWrapperClasses = createCardTextWrapperClasses({
      className,
      columnCard,
      metadata
    });
    const allTitleClasses = createCardTitleClasses({ className, metadata });
    const allDeckClasses = createCardDeckClasses({
      className,
      metadata,
      columnCard
    });
    const index = get(metadata, 'index');

    return (
      <div
        data-index={index}
        className={cardWrapClasses}
        onClick={event => cardEvent(event, index)}
      >
        <article className={cardClasses}>
          <FCLink
            currentSite={get(metadata, 'currentSite')}
            isVideo={get(metadata, 'isVideo')}
            to={get(metadata, 'link')}
            title={get(metadata, 'title')}
            env={env}
            externalLink={get(metadata, 'external')}
          >
            <Poster metadata={metadata} className={this.props.className} />
            <div className={textWrapperClasses}>
              <Eyebrow metadata={metadata} />
              <h2 className={allTitleClasses}>{get(metadata, 'title')}</h2>
              {hasExcerpt &&
                <h3 className={allDeckClasses}>{get(metadata, 'excerpt')}</h3>}
              {get(metadata, 'events')
                ? <button className="button__event-card">
                    {get(metadata, 'buttonText')}
                  </button>
                : ''}
            </div>
          </FCLink>
        </article>
      </div>
    );
  }
}

Card.defaultProps = {
  env: '',
  hasExcerpt: false,
  fullPageAdvertorial: false,
  columnCard: false,
  rowCardCount: 0,
  bigStory: false,
  cardEvent: () => {}
};

Card.propTypes = {
  className: PropTypes.string.isRequired,
  metadata: PropTypes.shape({}).isRequired,
  env: PropTypes.string,
  hasExcerpt: PropTypes.bool,
  fullPageAdvertorial: PropTypes.bool,
  columnCard: PropTypes.bool,
  rowCardCount: PropTypes.number,
  bigStory: PropTypes.bool,
  cardEvent: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/views/components/card/card.js